import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import Dashboard from '../components/Dashboard'
import Owners from '../components/Owners'
import Properties from '../components/Properties'
import Residents from '../components/Residents'
import PushNotifications from '../components/PushNotifications'
import Chat from '../components/Chat'

import AddOwner from '../components/Owners/AddOwner'
import AddProperty from '../components/Properties/AddProperty'
// import AddResident from '../components/Residents/AddResident'
import Details from '../components/Details'

import PropertyRoutes from './PropertyRoutes'

import AddPush from '../components/PushNotifications/AddPush'
import EditPush from '../components/PushNotifications/EditPush'

import ChatApp from '../components/Chat/ChatApp'

const AdminRoutes = ({ location, role }) => {
  return (
    <Switch location={location}>
      <Route key="dahsboard" exact path="/" component={Dashboard} />
      <Route key="owners" path="/owners" exact component={Owners} />
      <Route key="add_owner" path="/owners/add/owner" exact render={ () => <AddOwner isAgency={false}/> } />
      <Route key="add_agency" path="/owners/add/agency" exact render={ () => <AddOwner isAgency={true}/> } />
      <Route key="edit_owner" path="/owners/:id/edit/owner" exact render={ () => <AddOwner isAgency={false}/> } />
      <Route key="edit_agency" path="/owners/:id/edit/agency" exact render={ () => <AddOwner isAgency={true}/> } />

      <Route key="add_property" exact path="/owners/:id/property/add" component={AddProperty} />
      <Route key="properties" exact path="/properties" component={Properties} />
      <Route key="property" path="/properties/:id" component={PropertyRoutes} />
      <Route key="residents" exact path="/residents" component={Residents} />

      <Route key="add" path="/:category(owners|residents)/add" exact render={ () => null } />
      <Route key="detail" path="/:category(owners|residents)/:id" exact component={Details} />
      <Route key="push" exact path="/push" component={PushNotifications} />
      <Route key="add_push" exact path="/push/add" component={AddPush} />
      <Route key="add_custom_push" exact path="/push/add/:category(owner|property|resident)/:id" component={AddPush} />
      <Route key="edit_push" exact path="/push/edit/:id" component={EditPush} />
      <Route key="chat" exact path="/chat" component={Chat} />
      <Route key="chat_room" exact path="/chat/:category(owner|property|resident)/:id" component={Chat} />
      <Route key="chat_room" exact path="/chat/room/:id" component={ChatApp} />
    </Switch>

  )
}

export default withRouter(AdminRoutes)



// WEBPACK FOOTER //
// ./src/routes/AdminRoutes.jsx